import './pdx-banner.scss';
import './pdx-banner-loader';



// WEBPACK FOOTER //
// ./src/uScope/js/extensions/pdx-support/index.js